"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchoStackEffectHandler = exports.EchoStackEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class EchoStackEffectArgs {
    constructor(count) {
        this.count = count;
        this.__type = EffectType_1.EffectType.EchoStack;
        this.__typeName = "EchoStack";
        this.name = "Echo";
        this.harmful = false;
    }
}
exports.EchoStackEffectArgs = EchoStackEffectArgs;
let EchoStackEffectHandler = class EchoStackEffectHandler {
    apply(sequence, container, state) {
        state.meta.scriptHandlerId = container.registerEventHandler(state.targetId, EventType_1.EventType.AbilityUsed, Schedule_1.Schedule.Once(), new __1.CustomScriptEventHandlerArgs("Effect_EchoStack_OnAbilityUsed", {
            count: state.args.count
        }));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.scriptHandlerId);
    }
};
EchoStackEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.EchoStack)
], EchoStackEffectHandler);
exports.EchoStackEffectHandler = EchoStackEffectHandler;
